import { render } from "./TestKanbanMinimizedStage.vue?vue&type=template&id=bf96d70e&scoped=true"
import script from "./TestKanbanMinimizedStage.vue?vue&type=script&lang=js"
export * from "./TestKanbanMinimizedStage.vue?vue&type=script&lang=js"

import "./TestKanbanMinimizedStage.vue?vue&type=style&index=0&id=bf96d70e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf96d70e"]])

export default __exports__